import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { EuiComboBox, EuiComboBoxOptionOption, EuiFormLabel } from '@elastic/eui';
import { AVAILABLE_WEBSITES } from 'apollo-client/queries/getAvailableWebsites';
import { country, websites } from 'cache';
import { Query, QueryGetAvailableWebsitesArgs, VehicleDomain, Website } from 'generated/graphql';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const WebsiteFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const website_options = useReactiveVar(websites);
  const [onGetAvailableWebsites, { loading, data }] = useLazyQuery<Query, QueryGetAvailableWebsitesArgs>(
    AVAILABLE_WEBSITES
  );

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>
        <span>{formatMessage({ id: 'filters.website.label' })}</span>
      </EuiFormLabel>
      <EuiComboBox
        isLoading={loading}
        className="test-id-WebsiteFilter"
        placeholder={formatMessage({ id: 'filters.website.placeholder' })}
        options={data?.getAvailableWebsites?.map((x: string) => ({ label: x, value: x })) ?? []}
        selectedOptions={website_options?.map((x: string) => ({ label: x, value: x }))}
        onClick={(): void => {
          onGetAvailableWebsites({
            variables: {
              vehicleDomain: window.WHITE_LABEL_CONFIG.name.toUpperCase() as VehicleDomain,
              country: country(),
            },
          });
        }}
        onSearchChange={(): void => {
          onGetAvailableWebsites({
            variables: {
              vehicleDomain: window.WHITE_LABEL_CONFIG.name.toUpperCase() as VehicleDomain,
              country: country(),
            },
          });
        }}
        onChange={(x: EuiComboBoxOptionOption<string>[]): void => {
          websites(x?.map(({ value }) => value?.toUpperCase()) as Website[]);
        }}
      />
    </S.SidebarFilterWrapper>
  );
};
